import React from 'react';
import { motion } from 'framer-motion';
import { X, CheckCircle2, ArrowRight } from 'lucide-react';
export function TransformationSection() {
  // Replace previous 'before' and 'after' arrays with the new 'comparisons' array of objects
  const comparisons = [{
    before: 'Confundido, sin rumbo',
    after: 'Con claridad total'
  }, {
    before: 'Sin saber por dónde empezar',
    after: 'Con un camino paso a paso'
  }, {
    before: 'Dudando de cada decisión',
    after: 'Seguro de lo que hacés'
  }, {
    before: 'Gastando mal tu plata',
    after: 'Invirtiendo con criterio'
  }, {
    before: 'Perdiendo tiempo sin avanzar',
    after: 'Generando ingresos reales'
  }];
  return <section className="py-14 px-4 bg-[#0a0a0a] pt-[24px] pb-[24px]" data-id="element-284">
      <div className="max-w-3xl mx-auto pt-[0px] pb-[0px] mt-[0px] mb-[0px]" data-id="element-285">
        {/* Animate heading from the previous code with adjusted styles and text */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-286">
          <h2 className="md:text-4xl font-black text-[24px]" data-id="element-287">
            Tu <span className="text-brand-yellow" data-id="element-288">Antes y Después</span>
          </h2>
        </motion.div>

        {/* New comparison table with header and rows */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="rounded-2xl border border-gray-800 overflow-hidden bg-[#111]" data-id="element-289">
          {/* Table Header */}
          <div className="grid grid-cols-[1fr_auto_1fr] items-center bg-[#1a1a1a] border-b border-gray-800" data-id="element-290">
            <div className="px-5 py-4 text-center" data-id="element-291">
              <span className="text-sm md:text-base font-black text-red-400 uppercase tracking-wider" data-id="element-292">
                ❌ Sin la formación
              </span>
            </div>
            <div className="w-px h-full bg-gray-700" data-id="element-293" />
            <div className="px-5 py-4 text-center" data-id="element-294">
              <span className="text-sm md:text-base font-black text-green-400 uppercase tracking-wider" data-id="element-295">
                ✅ Con la formación
              </span>
            </div>
          </div>

          {/* Rows for each comparison */}
          {comparisons.map((row, i) => <motion.div key={i} initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className={`grid grid-cols-[1fr_auto_1fr] items-center ${i !== comparisons.length - 1 ? 'border-b border-gray-800/60' : ''} ${i % 2 === 0 ? 'bg-[#111]' : 'bg-[#0f0f0f]'}`} data-id="element-296">
              {/* Before item */}
              <div className="flex items-center gap-3 px-5 py-4" data-id="element-297">
                <X className="w-5 h-5 text-red-500/70 flex-shrink-0" data-id="element-298" />
                <p className="text-sm md:text-base text-gray-400 font-medium" data-id="element-299">
                  {row.before}
                </p>
              </div>
              {/* Arrow icon between columns */}
              <div className="flex items-center justify-center px-2" data-id="element-300">
                <ArrowRight className="w-4 h-4 text-brand-yellow" data-id="element-301" />
              </div>
              {/* After item */}
              <div className="flex items-center gap-3 px-5 py-4" data-id="element-302">
                <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-303" />
                <p className="text-sm md:text-base text-white font-semibold" data-id="element-304">
                  {row.after}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}